module.exports = __webpack_public_path__ + "static/media/avatar_26.ad6d50d6.svg";